import { render, staticRenderFns } from "./renewal-tracking-container.vue?vue&type=template&id=22a2f0e2"
import script from "./renewal-tracking-container.vue?vue&type=script&lang=ts"
export * from "./renewal-tracking-container.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports